export interface IXHRSuccess {
  ok: true;
  json(): any;
}
export interface IXHRFail {
  ok: false;
  status: number;
  statusText: string;
}
export type XHRResponse = IXHRSuccess | IXHRFail;

export function makeRequest(
  url: string,
  method: string,
  headers: Record<string, string>,
  body?: Document | BodyInit | null
) {
  const request = new XMLHttpRequest();
  request.responseType = 'json';
  return new Promise<XHRResponse>((resolve, reject) => {
    request.onreadystatechange = () => {
      if (request.readyState !== 4) {
        return;
      }
      if (request.status >= 200 && request.status < 300) {
        resolve({
          ok: true,
          json: () => JSON.parse(JSON.stringify(request.response)),
        });
      } else {
        reject({
          ok: false,
          status: request.status,
          statusText: request.statusText,
        });
      }
    };
    request.open(method || 'GET', url, true);
    Object.keys(headers).forEach(name => {
      request.setRequestHeader(name, headers[name]);
    });
    request.send(body);
  });
}
